import { render, staticRenderFns } from "./MerchantLogin.vue?vue&type=template&id=447f0b52&scoped=true&"
import script from "./MerchantLogin.vue?vue&type=script&lang=js&"
export * from "./MerchantLogin.vue?vue&type=script&lang=js&"
import style0 from "./MerchantLogin.vue?vue&type=style&index=0&id=447f0b52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f0b52",
  null
  
)

export default component.exports